import Axios from 'axios'
import store from '../store'

export default {
  getClientId () {
    return store.getters['Client/clientId']
  },
  approve (events) {
    return Axios.put(`/api/internal/clients/${this.getClientId()}/events/approve`, events)
  },
  reject (events) {
    return Axios.put(`/api/internal/clients/${this.getClientId()}/events/reject`, events)
  },
  getEvents (userMail) {
    if (userMail) {
      return Axios.get(`/api/internal/clients/${this.getClientId()}/events/approval?userEmail=${userMail}`)
    } else {
      return Axios.get(`/api/internal/clients/${this.getClientId()}/events/approval`)
    }
  }
}
